module.exports = __webpack_public_path__ + "img/82.c754c7a5.jpg";